import { FC, useCallback, useContext, useEffect, useMemo } from 'react';

import { Form as FormAntd, Table } from 'antd';

import {
  GenericDataFormContext,
  QuotationInfoContext,
} from '../../../../../../../shared';
import { ContentSection, SwitchForm } from '../../../../../../../../../../../shared/components';

import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';

import { Feature } from '../../../../../../../../../../../shared/interfaces';

import './index.css';

const MOCK_TABLE_COLUMNS_HEADER = [
  {
    title: 'Item',
    dataIndex: 'codeItem',
    width: '10%',
  },
  {
    title: 'Descripción de Características',
    dataIndex: 'featureDescription',
    width: '80%',
  },
  {
    title: '¿Tiene?',
    dataIndex: 'hasItem',
    width: '10%',
  },
];

interface TableFeaturesProps {
  duplicateId?: number;
  id: number;
}

export const TableFeatures: FC<TableFeaturesProps> = ({ duplicateId, id }) => {
  const { loadSaveQuotationState, quotationToRenewal, savedQuotation } = useContext(QuotationInfoContext);
  const quotation = quotationToRenewal ?? savedQuotation;
  const { stepThreeForm, allFeatures, getFeaturesRiskByPlan } =
    useContext(StepThreeFormContext);

  const planFormItemName = `plan-tab-${id}`;
  const planSelected = FormAntd.useWatch(planFormItemName, stepThreeForm);

  const setFeaturesTable = useMemo(
    () =>
      allFeatures?.find((feature) => feature.keyTab === id)?.features?.length
        ? allFeatures
          ?.find((feature) => feature.keyTab === id)
          ?.features?.map((feature: Feature) => ({
            codeItem: feature.codigo,
            featureDescription: feature.descripcion,
            hasItem: (
              <SwitchForm
                formProps={{
                  initialValue: feature.valorPorDefecto,
                  name: `feature-tab-${id}-${feature.codigo}`,
                }}
                switchProps={{ disabled: !feature.permiteModificar }}
              />
            ),
            key: feature.codigo,
          }))
        : [],
    [allFeatures]
  );

  useEffect(() => {
    if (duplicateId) {
      const allFieldsValues = stepThreeForm?.getFieldsValue(true);

      const duplicatedFieldsValues = Object.keys(allFieldsValues).reduce(
        (acc, key) => {
          if (key.includes(`feature-tab-${duplicateId}`)) {
            const newKey = key.replace(
              `feature-tab-${duplicateId}-`,
              `feature-tab-${id}-`
            );
            acc[newKey] = allFieldsValues[key];
          }

          return acc;
        },
        {} as Record<string, any>
      );

      stepThreeForm?.setFieldsValue(duplicatedFieldsValues);
    }
  }, [duplicateId, id, stepThreeForm]);

  useEffect(() => {
    if (planSelected && !loadSaveQuotationState) {
      const bien = quotation?.bienes?.[id - 1];
      getFeaturesRiskByPlan(
        id,
        planSelected,
        Number(bien?.numeroComponente ?? id)
      );
    }
  }, [planSelected, getFeaturesRiskByPlan, loadSaveQuotationState, id, quotation]);

  return (
    <ContentSection level='h3' title='Características' hasCard={false}>
      <Table
        bordered
        columns={MOCK_TABLE_COLUMNS_HEADER}
        dataSource={setFeaturesTable}
        pagination={false}
        className='person-table'
        scroll={{ x: 'auto' }}
      />
    </ContentSection>
  );
};
